<template>
    <div>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        <v-dialog v-model="changeCreditsDialog" max-width="500">
            <v-card>
                <v-tabs v-model="activeSuite" background-color="primary" dark centered>
                    <v-tab>RS</v-tab>
                    <v-tab>CS</v-tab>
                    <v-tab>MS</v-tab>
                </v-tabs>

                <v-card-title> Company: {{ selectedItem ? selectedItem.company_id : "" }} </v-card-title>

                <v-card-subtitle>Change Credits</v-card-subtitle>

                <v-card-subtitle>
                    {{
                        activeSuite == 0
                            ? "RS Count now: " + (selectedItem ? selectedItem.count : "")
                            : activeSuite == 1
                            ? "CS new projects now: " + (selectedItem ? selectedItem.content_new_projects : "")
                            : "MS Keywords now: " + (selectedItem ? selectedItem.monitoring_keywords : "")
                    }}
                </v-card-subtitle>
                <v-card-subtitle>
                    {{
                        activeSuite == 0
                            ? "RS Credits limit: " + (selectedItem ? selectedItem.credits : "")
                            : activeSuite == 1
                            ? "CS new projects limit: " + (selectedItem ? selectedItem.content_new_projects_limit : "")
                            : "MS Keywords limit: " + (selectedItem ? selectedItem.monitoring_keywords_limit : "")
                    }}
                </v-card-subtitle>

                <v-tabs-items v-model="activeSuite">
                    <v-tab-item>
                        <v-card-text>
                            <v-text-field v-model="newcredits.rs.count" label="RS Count" type="number" color="primary" />
                        </v-card-text>
                        <v-card-text>
                            <v-text-field v-model="newcredits.rs.limit" label="RS Limit" type="number" color="primary" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeCredits('rs')">
                                Change RS Credits
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card-text>
                            <v-text-field v-model="newcredits.cs.count" label="CS Count" type="number" color="primary" />
                        </v-card-text>
                        <v-card-text>
                            <v-text-field v-model="newcredits.cs.limit" label="CS Limit" type="number" color="primary" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeCredits('cs')">
                                Change CS Credits
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>

                    <v-tab-item>
                        <!-- <v-card-text>
                            <v-text-field v-model="newcredits.ms.count" label="MS Count" type="number" color="primary" />
                        </v-card-text> -->
                        <v-card-text>
                            <v-text-field v-model="newcredits.ms.limit" label="MS Limit" type="number" color="primary" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeCredits('ms')">
                                Change MS Credits
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-dialog>

        <!-- Change StartDate Dialog -->
        <v-dialog v-model="changeStartDateDialog" max-width="500">
            <v-card>
                <v-tabs v-model="activeSuite" background-color="primary" dark centered>
                    <v-tab>RS</v-tab>
                    <v-tab>CS</v-tab>
                    <v-tab>MS</v-tab>
                </v-tabs>

                <v-card-title> Company: {{ selectedItem ? selectedItem.company_id : "" }} </v-card-title>

                <v-card-subtitle>
                    {{
                        activeSuite == 0
                            ? "RS Start Date: " +
                              selectedItem.startdate
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join(".")
                            : activeSuite == 1
                            ? "CS Start Date: " +
                              selectedItem.content_start_date
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join(".")
                            : "MS Start Date: " +
                              selectedItem.monitoring_start_date
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join(".")
                    }}
                </v-card-subtitle>

                <v-tabs-items v-model="activeSuite">
                    <v-tab-item>
                        <v-card-text>
                            <v-text-field color="primary" v-model="newstartdate" type="date" label="RS Start Date" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeStartDate('rs')">
                                Change RS Start Date
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card-text>
                            <v-text-field color="primary" v-model="newstartdate" type="date" label="CS Start Date" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeStartDate('cs')">
                                Change CS Start Date
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card-text>
                            <v-text-field color="primary" v-model="newstartdate" type="date" label="MS Start Date" />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeStartDate('ms')">
                                Change MS Start Date
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-dialog>
        <v-dialog v-model="statusDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Suite-Status verwalten</span>
                </v-card-title>

                <v-card-text>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th>Suite</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(suite, key) in suites" :key="key">
                                <td>{{ suite.name }}</td>
                                <td>
                                    <v-select :items="suite.name == 'Research Suite' ? statusOptions : cs_ms_status_options" v-model="suite.status" outlined dense hide-details></v-select>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="statusDialog = false">Abbrechen</v-btn>
                    <v-btn color="primary" @click="switchStatus">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table :headers="headers" :items="items" :search="search" :single-expand="false" :expanded.sync="expanded" item-key="company_id" show-expand>
            <template v-slot:item.actions="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <!-- <v-list-item @click="editCompany(item)">
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item
                            @click="
                                selectedItem = item
                                newcredits.rs.limit = item.credits
                                newcredits.cs.limit = item.content_new_projects_limit
                                newcredits.ms.limit = item.monitoring_keywords_limit
                                newcredits.rs.count = item.count
                                newcredits.cs.count = item.content_new_projects
                                changeCreditsDialog = true
                            "
                        >
                            <v-list-item-title>change credits</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="
                                selectedItem = item
                                changeStartDateDialog = true
                            "
                        >
                            <v-list-item-title>change startdate</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="
                                selectedItem = item
                                suites.rs.status = item.company_status
                                suites.cs.status = item.content_status
                                suites.ms.status = item.monitoring_status
                                statusDialog = true
                            "
                        >
                            <v-list-item-title>change status</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <!-- <td :colspan="headers.length">
                    Requests Overall: {{ item.requestCount > 0 ? item.requestCount : 0 }}
                    <br />
                    Update requests overall: {{ item.requestsUpdates > 0 ? item.requestsUpdates : 0 }}
                    <br />
                    Requests in last 30 days: {{ item.requestsCounts30Days > 0 ? item.requestsCounts30Days : 0 }}
                    <br />
                    Update requests in last 30 days: {{ item.requestsUpdates30Days > 0 ? item.requestsUpdates30Days : 0 }}
                </td> -->
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        data: () => ({
            /**********************************************************
             * Overview of Companies Datatable:
             **********************************************************/
            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            editDialog: false,
            editedItem: {
                name: "",
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0
            },
            expanded: [],
            singleExpand: false,

            search: "",
            headers: [
                { text: "ID", filterable: true, sortable: true, value: "company_id" },
                { text: "Name", filterable: true, sortable: true, value: "name" },
                { text: "RS Status", filterable: true, sortable: true, value: "company_status" },
                { text: "RS Count", filterable: false, sortable: true, value: "count" },
                { text: "RS Credits", filterable: false, sortable: true, value: "credits" },
                { text: "RS Startdate", filterable: false, sortable: true, value: "startdate" },
                { text: "CS Plan", filterable: false, sortable: true, value: "content_plan" },
                { text: "CS New Projects", filterable: false, sortable: true, value: "content_new_projects" },
                { text: "CS New Projects Credits", filterable: false, sortable: true, value: "content_new_projects_limit" },
                // { text: "CS Active Projects", filterable: false, sortable: true, value: "active_projects" },
                // { text: "CS Active Projects Credits", filterable: false, sortable: true, value: "active_projects_limit" },
                { text: "CS Adhoc WDF*IDF", filterable: false, sortable: true, value: "content_adhoc_wdfidf_count" },
                { text: "CS Adhoc WDF*IDF Credits", filterable: false, sortable: true, value: "content_adhoc_wdfidf_limit" },
                { text: "CS Startdate", filterable: false, sortable: true, value: "content_start_date" },
                { text: "CS Status", filterable: false, sortable: true, value: "content_status" },
                { text: "MS Plan", filterable: false, sortable: true, value: "monitoring_plan" },
                { text: "MS Keywords", filterable: false, sortable: true, value: "monitoring_keywords" },
                { text: "MS Keywords Credits", filterable: false, sortable: true, value: "monitoring_keywords_limit" },
                { text: "MS Startdate", filterable: false, sortable: true, value: "monitoring_start_date" },
                { text: "MS Status", filterable: false, sortable: true, value: "monitoring_status" },
                { text: "Actions", filterable: false, sortable: false, value: "actions" },
                { text: "", value: "data-table-expand" }
            ],
            items: [],
            selectedItem: {},
            activeSuite: 0,
            newcredits: {
                rs: { limit: 0, count: 0 },
                cs: { limit: 0, count: 0 },
                ms: { limit: 0, count: 0 }
            },

            //change credits dialog
            changeCreditsDialog: false,

            //change startdate dialog
            changeStartDateDialog: false,
            newstartdate: new Date(),

            statusDialog: false,
            suites: {
                rs: { name: "Research Suite", status: "active" },
                cs: { name: "Content Suite", status: "inactive" },
                ms: { name: "Monitoring Suite", status: "testing" }
            },
            statusOptions: ["testing", "active", "test_ended", "inactive", "free"]
        }),
        computed: {
            cs_ms_status_options() {
                return this.statusOptions.filter((x) => x !== "inactive" && x !== "free")
            }
        },
        methods: {
            async switchStatus() {
                try {
                    // Alle drei Requests gleichzeitig starten
                    await Promise.all([
                        this.$http.post(
                            process.env.VUE_APP_APIURL + "/admin/company/switch/status",
                            { company_id: this.selectedItem.company_id, newstatus: this.suites.rs.status },
                            { headers: { Authorization: this.auth } }
                        ),
                        this.$http.post(
                            process.env.VUE_APP_APIURL + "/admin/company/cs/change/status",
                            { company_id: this.selectedItem.company_id, new_status: this.suites.cs.status },
                            { headers: { Authorization: this.auth } }
                        ),
                        this.$http.post(
                            process.env.VUE_APP_APIURL + "/admin/company/ms/change/status",
                            { company_id: this.selectedItem.company_id, new_status: this.suites.ms.status },
                            { headers: { Authorization: this.auth } }
                        )
                    ])

                    // Nachdem alle abgeschlossen sind
                    this.statusDialog = false
                    this.fetchCredits()
                } catch (error) {
                    console.error(error)
                }
            },
            changeCredits(suite) {
                Promise.all([
                    this.$http.post(
                        process.env.VUE_APP_APIURL + "/admin/monitoring/credits/set",
                        { credits: this.newcredits[suite].limit, company_id: this.selectedItem.company_id, suite: suite },
                        { headers: { Authorization: this.auth } }
                    ),
                    this.$http.post(
                        process.env.VUE_APP_APIURL + "/admin/monitoring/count/set",
                        { credits: this.newcredits[suite].count, company_id: this.selectedItem.company_id, suite: suite },
                        { headers: { Authorization: this.auth } }
                    )
                ])
                    .then(([creditsResponse, countResponse]) => {
                        console.log(creditsResponse.body)
                        console.log(countResponse.body)
                        this.fetchCredits()
                        this.changeCreditsDialog = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            changeStartDate(suite) {
                this.$http
                    .post(
                        process.env.VUE_APP_APIURL + "/admin/monitoring/credits/set/startdate",
                        { new_startdate: this.newstartdate, company_id: this.selectedItem.company_id, suite: suite },
                        { headers: { Authorization: this.auth } }
                    )
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCredits()
                        this.changeStartDateDialog = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchCredits: function() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/monitoring/credits", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.items = response.body.credits.map((x) => {
                            x.startdate = new Date(x.startdate).toLocaleDateString("de-DE")
                            x.content_start_date = new Date(x.content_start_date).toLocaleDateString("de-DE")
                            // console.log(new Date(x.monitoring_start_date).toLocaleDateString("de-DE"))

                            x.monitoring_start_date = new Date(x.monitoring_start_date).toLocaleDateString("de-DE")
                            return x
                        })
                        this.selectedItem = response.body.credits[0]
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        mounted() {
            this.fetchCredits()
        }
    }
</script>
